import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Landing from './components/Landing';
import AdminMenu from './components/AdminMenu';
import OrderForm from './components/OrderForm';
import EditCatalog from './components/EditCatalog';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from 'react-router-dom';

const darkBlueTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0a2342',
      light: '#19376d',
      dark: '#071a2c',
      contrastText: '#fff',
    },
    secondary: {
      main: '#274690',
      light: '#576ca8',
      dark: '#1b2a49',
      contrastText: '#fff',
    },
    background: {
      default: '#f4f6fb',
      paper: '#e9ecf5',
    },
    success: {
      main: '#1e90ff',
      dark: '#1565c0',
      light: '#63a4ff',
      contrastText: '#fff',
    },
    text: {
      primary: '#0a2342',
      secondary: '#274690',
    },
    action: {
      hover: '#e3eafc',
    } as any,
  },
});


const NavBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem('token'));
  // Hide on login page
  if (location.pathname === '/login') return null;
  if (!isLoggedIn) return null;
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('isAdmin');
    navigate('/login');
  };
  return (
    <AppBar position="static" color="primary" sx={{ mb: 2 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700, letterSpacing: 1 }}>
          RVA Raw Food Co-Op
        </Typography>
        <Button color="inherit" onClick={handleLogout} sx={{ fontWeight: 600 }}>Logout</Button>
      </Toolbar>
    </AppBar>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={darkBlueTheme}>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Landing />
            </ProtectedRoute>
          } />
          <Route path="/order" element={
            <ProtectedRoute>
              <OrderForm />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminMenu />
            </ProtectedRoute>
          } />
          <Route path="/edit-catalog" element={
            <ProtectedRoute>
              <EditCatalog />
            </ProtectedRoute>
          } />
          <Route path="/consolidated-order" element={
            <ProtectedRoute>
              {React.createElement(require('./components/ConsolidatedOrder').default)}
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;